import React, { createContext, useState, useEffect, useContext } from 'react';
import * as api from '../services/api';

const ContentContext = createContext();

export const useContent = () => useContext(ContentContext);

export const ContentProvider = ({ children }) => {
    const [contents, setContents] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        loadContent();
    }, []);

    const loadContent = async () => {
        try {
            setLoading(true);
            const data = await api.getSiteSections();
            setContents(Array.isArray(data) ? data.sort((a, b) => a.id - b.id) : []);
        } catch (err) {
            console.error("Failed to load content:", err);
            setError(err.message);
        } finally {
            setLoading(false);
        }
    };

    const addContent = async (content) => {
        try {
            const newContent = await api.addSiteSection(content);
            setContents(prev => [...prev, newContent]);
            return newContent;
        } catch (err) {
            console.error("Failed to add content:", err);
            throw err;
        }
    };

    const updateContent = async (id, updatedContent) => {
        try {
            const result = await api.updateSiteSection(id, updatedContent);
            setContents(prev => prev.map(item => (item.id === id ? result : item)));
            return result;
        } catch (err) {
            console.error("Failed to update content:", err);
            throw err;
        }
    };

    const deleteContent = async (id) => {
        try {
            await api.deleteSiteSection(id);
            setContents(prev => prev.filter(item => item.id !== id));
        } catch (err) {
            console.error("Failed to delete content:", err);
            throw err;
        }
    };

    const getContentById = (id) => {
        return contents.find(item => item.id === parseInt(id));
    };

    return (
        <ContentContext.Provider value={{ contents, loading, error, addContent, updateContent, deleteContent, getContentById }}>
            {children}
        </ContentContext.Provider>
    );
};
